import { render, staticRenderFns } from "./PackagedService.vue?vue&type=template&id=52eef6e0&scoped=true"
import script from "./PackagedService.vue?vue&type=script&lang=js"
export * from "./PackagedService.vue?vue&type=script&lang=js"
import style0 from "./PackagedService.vue?vue&type=style&index=0&id=52eef6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eef6e0",
  null
  
)

export default component.exports